module.exports = __webpack_public_path__ + "lr.svg?905d588535481f3cc8e1f60ad04b4b65";